var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SystemBar'),(_vm.customer && _vm.customer.email)?_c('div',[_c('FormValidateEmail',{attrs:{"customer":_vm.customer}})],1):_c('div',[_c('Empty',{on:{"goBack":function($event){return _vm.$router.replace({ path: '/' })}}})],1),_c('OcularSign')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }